import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// The initial bundle is present; a later visit may recover independently.
try { sessionStorage.removeItem('aw-startup-retry'); } catch (_) {}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
